export enum NotificationPreferenceEnum {
    None = "None",
    Promotional = "Promotional"
}
